import axios from "axios";
import { API } from "../../../backend";
import authHeader from "../../auth-header"
const getPartyAddressDetails = (state) => {
  
  return axios.get(API + "parties/address-edit/"+state+"/",{headers: authHeader(),});
};
const editPartyAddressDetails = (id, address_line_1, address_line_2,city,state,zip_code,country,bill_to,ship_to,install_to,attribute) => {
    return axios.post(API + "parties/address-edit/" +id+"/", {
        // id,
        address_line_1,
        address_line_2,
        city,
        state,
        zip_code,
        country,
        bill_to,
        ship_to,
        install_to,
        attribute
    },{headers: authHeader(),});
  };
const EditAddressService = {
    getPartyAddressDetails,
    editPartyAddressDetails,
  };
  export default EditAddressService;